<div class="w-full flex tilt-card-flex">
  <div
    *ngFor="let latestData of sensorData?.tilt"
    class="w-full tilt-card-flex__item"
  >
    <app-site-detail-tilt-sensor [tiltData]="latestData">
    </app-site-detail-tilt-sensor>
  </div>
</div>
